/* eslint-disable new-cap */
import React from "react"
import PropTypes from "prop-types"
import Tooltip from "app/static/frontend/components/Tooltip"
import classNames from "classnames"
import useDimensions from "react-cool-dimensions"

import { decodeStyles, calculateTextWidth } from "imports/styleHelperFunctions"

// styles
import "app/static/stylus/sheet.styl"
import sheetVars from "app/static/stylus/sheets-variables.json"

const sheetsVariables = decodeStyles(sheetVars)

/**
 * Component to render a column's name
 */
export function ColumnName({ columnName, canRenameColumns, handleRenameColumn }) {
    const { observe, width: maxWidth } = useDimensions()

    // to calculate the width of the name, let's build a fake div with the columnName
    const textWidth = calculateTextWidth(sheetsVariables.columnNameFont, columnName)
    const showTooltip = textWidth > maxWidth

    if (showTooltip) {
        return (
            <Tooltip label={columnName}>
                <div // eslint-disable-line
                    onClick={handleRenameColumn}
                    className={classNames("column-name-text", { "column-name-pointer": canRenameColumns })}
                    style={{ maxWidth: `${maxWidth}px` }}
                    ref={observe}
                >
                    {`${columnName} `}
                </div>
            </Tooltip>
        )
    } else {
        return (
            <div // eslint-disable-line
                className={classNames("column-name-text", { "column-name-pointer": canRenameColumns })}
                onClick={handleRenameColumn}
                style={{ maxWidth: `${maxWidth}px` }}
                ref={observe}
            >
                {columnName ? `${columnName}` : "Untitled"}
            </div>
        )
    }
}

ColumnName.propTypes = {
    columnName: PropTypes.string,
    canRenameColumns: PropTypes.bool,
    handleRenameColumn: PropTypes.bool,
}

ColumnName.defaultProps = {}

export default ColumnName
